<template>
    <div>
        <img :src="imageUrl" :alt="alt" @click="onClick"/>
        <div v-if="isEditing">
            <image-uploader
                :showModal="showModal"
                @imageChanged="onImageChanged"
                @closeModal="showModal = false"
            />
        </div>
    </div>
</template>

<script>

import { getProfileImage } from '@/api/profile.js';
import ImageUploader from '@/components/common/ImageUploader.vue';

export default {
name: 'ProfileImage',
components: {
    ImageUploader,
},
props: {
    userId: {
        type: [Number,String],
        required: true,
    },
    alt: {
        type: String,
        required: false,
    },
    isEditing: {
        type: Boolean,
        required: false,
    },

},

emits: ['imageChanged'],

data() {
    return{
    imageUrl: null,
    showModal: false,
    }
},

methods: {
    async fetchImage() {

        try {

            // Fetch image data as blob from the API
            const imageBlob = await getProfileImage(this.userId);

            // Revoke any previous object URL to avoid memory leaks
            if (this.imageUrl) {
                URL.revokeObjectURL(this.imageUrl);
            }
            
            // Create an object URL from the blob and assign it to imageUrl
            this.imageUrl = URL.createObjectURL( imageBlob);

            //console.log("imageUrl: " + this.imageUrl);

        } catch (error) {
            console.error('Error fetching the image:', error);
            this.error = "Failed to load image. Please try again.";
            this.imageUrl = null;
        }
    },

    onImageChanged(selectedFile) {
      // Handle the updated image URL
      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl); // Revoke old object URL
      }
      this.imageUrl = URL.createObjectURL(selectedFile); // Assign the new image URL
      this.selectedFile = selectedFile;
      this.$emit('imageChanged', selectedFile);
    },

    onClick() {
        if (this.isEditing) {
            this.showModal = true;
        }
    },
},

created() {
    this.fetchImage();
},

};
</script>